import React from 'react';

const Contact = () => {
  return (
    <div
      name="contact"
      className=" w-full h-screen bg-[#0a192f] text-black flex justify-center items-center p-4 pt-20 "
    >
      <form
        action="https://getform.io/f/fab07144-2e9c-4503-8789-fd60a7e83d36"
        method="POST"
        className="flex flex-col max-w-[600px] w-full "
        enctype="multipart/form-data"
      >
        <div className="pb-8 text-center">
          <p className="text-4xl font-bold inline border-b-4 text-gray-300 border-blue-600">
            Contact
          </p>
          <p className="text-gray-300 py-4">
            Submit the form below or shoot me an email
          </p>
        </div>
        <input
          className="bg-[#ccd6f6] p-2"
          type="text"
          placeholder="Name"
          name="name"
          required
          minlength="3"
        />
        <input
          className="my-4 p-2 bg-[#ccd6f6]"
          type="email"
          placeholder="Email"
          name="email"
          required
        />
        <textarea
          className="bg-[#ccd6f6] p-2"
          name="message"
          placeholder="Message"
          rows={10}
          required
          minLength="4"
        ></textarea>
        <button
          className="text-white border-2 hover:bg-blue-600  hover:border-blue-600 px-4 py-3 my-8 mx-auto flex items-center hover:scale-105 duration-300 rounded-md"
          type="submit"
        >
          Let's Collaborate
        </button>
      </form>
    </div>
  );
};

export default Contact;
